<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 v-if="!current.pk" class="form-header">Nuevo Grupo de Activo</h5>
                <div v-if="!current.pk" class="form-desc">Adición Grupo de Activo</div>
                <h5 v-if="current.pk" class="form-header">Edición de Grupo de Activo</h5>

                <div class="row">
                  <div class="col-lg-3 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.id && current.errors.id.length > 0,
                        }"
                        >Id</label
                      >
                      <input
                        v-model="current.id"
                        :disabled="true"
                        class="form-control"
                        autofocus="autofocus"
                        placeholder="Id"
                        :readonly="current.pk"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors.id && current.errors.id.length > 0,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.id"
                        class="form-text text-danger"
                        >{{ current.errors.id[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-lg-9 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.nombre && current.errors.nombre.length > 0,
                        }"
                        >Nombre</label
                      >
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{
                          'is-invalid':
                            current.errors.nombre && current.errors.nombre.length > 0,
                        }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                        >{{ current.errors.nombre[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.descripcion &&
                            current.errors.descripcion.length > 0,
                        }"
                        >Descripción</label
                      >
                      <textarea
                        v-model="current.descripcion"
                        class="form-control"
                        placeholder="Descripción"
                        v-bind:class="{
                          'is-invalid':
                            current.errors.descripcion &&
                            current.errors.descripcion.length > 0,
                        }"
                        rows="5"
                      ></textarea>
                      <small
                        v-if="current.errors && current.errors.descripcion"
                        class="form-text text-danger"
                        >{{ current.errors.descripcion[0] }}</small
                      >
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'af-grupos', params: {} }"
                  >
                    <i class="fas fa-angle-left"></i>
                    Volver al Listado
                  </router-link>
                  <button class="btn btn-primary" type="submit">Guardar <i class="fas fa-check"></i></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import AfGruposService from "@/services/af/AfGruposService";

export default {
  data() {
    return {
      current: {
        errors: {},
      },
      data: [],
    };
  },

  computed: {},
  mounted() {
    if (this.$route.params.id) {
      this.refreshData();
    }
  },

  methods: {
    refreshData() {
      AfGruposService.getById(this.$route.params.id).then((response) => {
        this.current = response.data;
        this.current.pk = this.current.id;
        this.current.errors = [];
      });
    },
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);

      if (this.$route.params.id == null) {
        delete current.pk;
      } else {
        current.pk = current.id;
      }
      AfGruposService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.pk = self.current.id;
          self.current.errors = {};
          Notifications.alert.success(
            "Grupos de Activos Fijos",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "af-grupos-editar",
            params: { id: res.data.id },
          });
        })
        .catch((error) => {
          if (error.response) {
            self.current.errors = error.response.data;
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
  },
};
</script>
